import { Route, Routes } from 'react-router-dom'
import RequireAdmin from '../auth/RequireAdmin'
import { ToastProvider } from './useToast'
import AdminShell from './AdminShell'
import AdminEventsPage from './pages/AdminEventsPage'
import AdminEventFormPage from './pages/AdminEventFormPage'
import AdminEventDetailPage from './pages/AdminEventDetailPage'
import AdminResponsesPage from './pages/AdminResponsesPage'
import AdminReportsPage from './pages/AdminReportsPage'
import AdminTemplatesPage from './pages/AdminTemplatesPage'
import AdminKioskScanPage from './pages/AdminKioskScanPage'
import AdminPeoplePage from './pages/AdminPeoplePage'
import AdminSettingsPage from './pages/AdminSettingsPage'

/** The admin console: gated by role, wrapped in the admin shell + toasts. */
export default function AdminApp() {
  return (
    <RequireAdmin>
      <ToastProvider>
        <AdminShell>
          <Routes>
            <Route index element={<AdminEventsPage />} />
            <Route path="templates" element={<AdminTemplatesPage />} />
            <Route path="people" element={<AdminPeoplePage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
            <Route path="events/new" element={<AdminEventFormPage />} />
            <Route path="events/:id" element={<AdminEventDetailPage />} />
            <Route path="events/:id/edit" element={<AdminEventFormPage />} />
            <Route path="events/:id/checkin/scan" element={<AdminKioskScanPage />} />
            <Route path="events/:id/reports" element={<AdminReportsPage />} />
            <Route
              path="events/:id/forms/:formId/responses"
              element={<AdminResponsesPage />}
            />
          </Routes>
        </AdminShell>
      </ToastProvider>
    </RequireAdmin>
  )
}
